import React from "react";
import "../../styles/components/profile_page/PackagesPanel.css";

/**
 * PackagesPanel (placeholder)
 *
 * Props (optional):
 * - title?: string
 * - packages?: Array<{
 *     id: string;
 *     name: string;
 *     price?: string;       // e.g. "£149"
 *     duration?: string;    // e.g. "2 hours"
 *     includes?: string[];  // bullets
 *     highlight?: boolean;  // accent style
 *   }>
 *
 * If no packages are passed, a neutral empty-state card is shown.
 */
export default function PackagesPanel({
  title = "Packages",
  packages = [],
  isOwner = false,
  firstName
}) {
  const hasData = packages && packages.length > 0;

  return (
    <section className="packagesPanel profile-panel">
      <h3 className="packagesPanel__title">{title}</h3>

      {!hasData ? (
        <div className="packagesPanel__empty">
          <div className="packagesPanel__emptyTitle">
            {isOwner
              ? "No packages listed"
              : `${firstName || "This photographer"} hasn't listed any packages yet.`}
          </div>
          {isOwner && (
            <div className="packagesPanel__emptyBody">
              Add some package options to help clients understand what you offer.
            </div>
          )}
        </div>
      ) : (
        <div className="packagesPanel__grid">
          {packages.map((p) => (
            <article
              key={p.id}
              className={`packagesPanel__card ${p.highlight ? "is-highlight" : ""}`}
            >
              <header className="packagesPanel__header">
                <h4 className="packagesPanel__name">{p.name}</h4>
                {(p.price || p.duration) && (
                  <div className="packagesPanel__meta">
                    {p.price && <span className="packagesPanel__price">{p.price}</span>}
                    {p.duration && <span className="packagesPanel__dot">•</span>}
                    {p.duration && <span className="packagesPanel__duration">{p.duration}</span>}
                  </div>
                )}
              </header>

              {p.includes?.length ? (
                <ul className="packagesPanel__list">
                  {p.includes.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : (
                <div className="packagesPanel__placeholder">
                  What’s included…
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  );
}